var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 22C8.82441 22 6.69767 21.3549 4.88873 20.1462C3.07979 18.9375 1.66989 17.2195 0.83733 15.2095C0.00476611 13.1995 -0.213071 10.9878 0.211367 8.85401C0.635804 6.72022 1.68345 4.76021 3.22183 3.22183C4.76021 1.68345 6.72022 0.635804 8.85401 0.211367C10.9878 -0.213071 13.1995 0.00476611 15.2095 0.83733C17.2195 1.66989 18.9375 3.07979 20.1462 4.88873C21.3549 6.69767 22 8.82441 22 11C22 13.9174 20.8411 16.7153 18.7782 18.7782C16.7153 20.8411 13.9174 22 11 22ZM11 1.57143C9.13521 1.57143 7.31229 2.12441 5.76177 3.16043C4.21125 4.19646 3.00277 5.669 2.28914 7.39185C1.57551 9.11469 1.3888 11.0105 1.7526 12.8394C2.1164 14.6684 3.01439 16.3484 4.333 17.667C5.65161 18.9856 7.33162 19.8836 9.16058 20.2474C10.9895 20.6112 12.8853 20.4245 14.6082 19.7109C16.331 18.9972 17.8035 17.7888 18.8396 16.2382C19.8756 14.6877 20.4286 12.8648 20.4286 11C20.4286 8.49939 19.4352 6.1012 17.667 4.333C15.8988 2.5648 13.5006 1.57143 11 1.57143Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4969 15.4816L10.5928 11.2305V4.07422H11.9896V10.5993L15.4817 14.4093L14.4969 15.4816Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeImg);
export default __webpack_public_path__ + "static/media/time_img.2ab838d6703304dceaf9e32b5d00dd16.svg";
export { ForwardRef as ReactComponent };